import { Card } from '@heroui/react';
import styled from 'styled-components';

interface BoxWrapperProps {
    maxWidth?: string;
    isTransparent?: boolean;
    isDanger?: boolean;
    isAlert?: boolean;
    isMerge?: boolean;
}

export const ActionBlockWrapper = styled(Card)<BoxWrapperProps>`
    box-sizing: border-box;
    background: ${({ isDanger, theme }) => {
    if (isDanger) return theme.mode === 'dark' ? '#3f1d1d' : '#ffeeef';
    if (theme.mode === 'dark') return '#242a33';
    return theme.colors.card.background;
  }};
    width: ${({ maxWidth }) => maxWidth || '100%'};
    margin-bottom: 15px;
    position: relative;
    align-items: center;
    align-self: flex-start;
    border-radius: ${({ isAlert, isMerge }) => {
    if (isMerge || isAlert) return '0 0 6px 6px';
    return '6px';
  }};
    padding: 15px 20px;
    border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : theme.colors.card.border)};

    @media (max-width: 768px) {
        padding: 10px;
    }
    border-top: ${({ isMerge, theme }) => (isMerge ? 'none' : `1px solid ${theme.mode === 'dark' ? '#374151' : theme.colors.card.border}`)};
    overflow: auto !important;
    transition: background 0.2s ease, border-color 0.2s ease;
`;

export const ActionBlockContainer = styled.div`
    width: 100%;
`;

export const ActionBlockInfo = styled.div`
    margin-bottom: 15px;
`;

export const ActionBlockTitle = styled.h3`
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    padding: 0;
    max-width: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: ${({ theme }) => theme.colors.text.primary};
`;

export const ActionBlockDescription = styled.p`
    font-size: 14px;
    margin: 5px 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.text.secondary};
    line-height: 1.7;
`;

export const ActionBlockFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 12px 24px;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#ebebeb')};
    border-top: 1px solid ${({ theme }) => theme.colors.card.border};
`;

export const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const WarningBlockWrapper = styled.div`
    color: ${({ theme }) => (theme.mode === 'dark' ? '#fbbf24' : '#856404')};
    background-color: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(251, 191, 36, 0.15)' : '#fff3cd')};
    //border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? 'rgba(251, 191, 36, 0.3)' : '#e8ddb7')};
    padding: 12px 10px;
    //border-radius: 6px 6px 0 0;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    position: relative;
    line-height: 1.7;
    z-index: 2;
    top: 2px; 
`;
